import {modals, tags} from "../../ducks";
import {connect} from "react-redux";
import React, {useState} from "react";
import ModalComponent from "../ModalComponent";
import {Button} from "react-bootstrap";
import PropTypes from "prop-types";
import {TagName} from "./TagList";
import {pluralize} from "../../utils";


const DeleteTagModal = ({item, pluralItem, onClose, onDelete, onUnexpectedError, tag = {}}) => {
  const [loading, setLoading] = useState(false);
  pluralItem = pluralItem || `${item}s`;

  return <ModalComponent
    className="delete-tag-modal"
    title="Delete Tag"
    buttons={[
      <Button
        type="submit"
        onClick={() => {
          setLoading(true);
          onDelete(tag)
            .then(onClose)
            .catch(() => {
              onClose();
              onUnexpectedError();
            });
        }}
        disabled={loading}
      >
        {loading ? 'Deleting...' : 'Delete'}
      </Button>
    ]}
  >
    <p>You have chosen to delete <TagName>{tag.name}</TagName>.</p>

    {tag.usage_count !== 0 &&
      <p>It will be removed from {tag.usage_count} {pluralize(tag.usage_count, item, pluralItem)} and
        deleted. Continue?</p>}

    {tag.usage_count === 0 && <p>This tag is not used by any {pluralItem}.</p>}
  </ModalComponent>;
};

DeleteTagModal.propTypes = {
  /** Tag to remove */
  tag: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
  }),

  /** Name of the taggable item */
  item: PropTypes.string,

  /** Plural name of the taggable item */
  pluralItem: PropTypes.string,
};

DeleteTagModal.defaultProps = {
  item: 'item'
}

const mapDispatchToProps = (dispatch) => ({
  onDelete: tag => dispatch(tags.actions.remove(tag)),
  onClose: () => dispatch(modals.actions.hide()),
  onUnexpectedError: () => dispatch(modals.actions.show('UnexpectedError'))
});

export default connect(null, mapDispatchToProps)(DeleteTagModal);
